export class RandomCliApiService {
	constructor(CoreApi) {
		this.CoreApi = CoreApi;
	}
	list(params) {
		return this.CoreApi.makeApiCall("POST", "random_cli/list/", params).then(r => r.data);
	}
	delete(id) {
		return this.CoreApi.makeApiCall("POST", "random_cli/delete/", {id}).then(r => r);
	}
	create(data) {
		return this.CoreApi.makeApiCall("POST", "random_cli/create/", data).then(r => r);
	}
}